module.exports={
	"mobile": [
		{
			"name": "mobile",
			"title": "Select your product",
			"subTitle": "Select your product below and use our simple troubleshooting guide to diagnose the problem. If a repair is needed, we’ll take you through the steps to book online.",
			"categories": [
				{
					"name": "Smartphones",
					"displayName": "Smartphones",
					"image": "phones.svg",
					"tpImage": "smartphones.png",
					"alt": "Smartphones icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/s/group/Phones",
					"services": [
						"Pickup service",
						"Doorstep repairs",
						"Instore Repair"
					],
					"availableServices": "PS|DSR|ISR",
					"isProductMappingNotAvailable": false
				},
				{
					"name": "Tablets",
					"displayName": "Tablets",
					"image": "tablets.svg",
					"tpImage": "tablets.png",
					"alt": "Tablets icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/group/Tablets/",
					"services": [
						"Pickup service",
						"Doorstep repairs",
						"Instore Repair"
					],
					"availableServices": "PS|DSR|ISR",
					"isProductMappingNotAvailable": false
				},
				{
					"name": "Wearables",
					"displayName": "Wearables",
					"image": "wearables.svg",
					"tpImage": "wearables.png",
					"alt": "Wearables icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/s/group/Wearables/",
					"services": [
						"Pickup service",
						"Instore Repair"
					],
					"availableServices": "PS|ISR",
					"isProductMappingNotAvailable": false
				}
			],
			"tsTitle": "",
			"tsSubTitle": "",
			"alttroubleshootertext": ""
		}
	],
	"homeappliance": [
		{
			"name": "home-appliance",
			"title": "Select your product",
			"subTitlex": "Select your product below and use our simple troubleshooting guide to diagnose the problem. If a repair is needed, we will take you through the steps to book online.<br /> If you have any problems during the troubleshooting or booking process, <a href='javascript:void(0);' class='get-in-touch link'>get in touch</a> and we can help.",
			"subTitle": "Select your product below and use our simple troubleshooting guide to diagnose the problem. If a repair is needed, we will take you through the steps to book online.",
			"categories": [
				{
					"name": "Refrigerator",
					"displayName": "Refrigerators",
					"image": "refrigerator.svg",
					"tpImage": "refrigerator.png",
					"alt": "Refrigerator icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrlx": "https://samcustdotcom.likewizesupport.com/sam/refrigerator28.html",
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/refrigeratorkiss.html",
					"services": [
						"In Home Repair"
					],
					"availableServices": "IHTVDA",
					"isProductMappingNotAvailable": true
				},
				{
					"name": "Laundry",
					"displayName": "Laundry",
					"image": "washers-dryers.svg",
					"tpImage": "laundry.png",
					"alt": "Laundry icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrlx": "https://samcustdotcom.likewizesupport.com/sam/laundry28.html",
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/laundrykiss.html",
					"services": [
						"In Home Repair"
					],
					"availableServices": "IHTVDA",
					"isProductMappingNotAvailable": true
				},
				{
					"name": "Cooking",
					"displayName": "Cooking",
					"image": "cook.svg",
					"tpImage": "cooking.png",
					"alt": "Cooking icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrlx": "https://samsungcustomer.likewizesupport.com/sam/cooking.html",
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/cookingkiss.html",
					"services": [
						"In Home Repair"
					],
					"availableServices": "IHTVDA",
					"isProductMappingNotAvailable": true
				},
				{
					"name": "Dishwashers",
					"displayName": "Dishwashers",
					"image": "dishwashers.svg",
					"tpImage": "dishwashers.png",
					"alt": "Dishwashers icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrlx": "https://samcustdotcom.likewizesupport.com/sam/dishwasher.html",
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/dishwasherkiss.html",
					"services": [
						"In Home Repair"
					],
					"availableServices": "IHTVDA",
					"isProductMappingNotAvailable": true
				},
				{
					"name": "Vacuum Cleaners",
					"displayName": "Vacuum Cleaners",
					"image": "vaccums.svg",
					"tpImage": "vacuum-cleaners.png",
					"alt": "Vacuum Cleaners icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/group/Floorcare/",
					"services": [
						"Pickup service"
					],
					"availableServices": "PSTVDA",
					"isProductMappingNotAvailable": false
				}
			],
			"tsTitle": "",
			"tsSubTitle": "",
			"alttroubleshootertext": ""
		}
	],
	"tvav": [
		{
			"name": "tv-av",
			"title": "Select your product",
			"subTitlex": "Select your product below and use our simple troubleshooting guide to diagnose the problem. If a repair is needed, we’ll take you through the steps to book online.<br> If you have any problems during the troubleshooting or booking process, <a href='javascript:void(0);' class='get-in-touch link'>get in touch</a> and we can help.",
			"subTitle": "Select your product below and use our simple troubleshooting guide to diagnose the problem. If a repair is needed, we will take you through the steps to book online.",
			"categories": [
				{
					"name": "TV",
					"displayName": "TVs",
					"image": "tv.svg",
					"tpImage": "tv.png",
					"alt": "TV icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/tv.html",
					"services": ["Pickup service"],
          "availableServices": "PSTVDA",
					"isProductMappingNotAvailable": true
				},
				{
					"name": "Projector",
					"displayName": "Projectors",
					"image": "projectors.svg",
					"tpImage": "projector.png",
					"alt": "Projector icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/group/Projector",
					"services": ["Pickup service"],
					"availableServices": "PSTVDA",
					"isProductMappingNotAvailable": false
				},
				{
					"name": "AV",
					"displayName": "Sound Devices",
					"image": "av.svg",
					"tpImage": "av.png",
					"alt": "Audio Visual icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/group/AudioVideo/",
					"services": ["Pickup service"],
     			"availableServices": "PSTVDA",
					"isProductMappingNotAvailable": false
				},
				{
					"name": "Harman JBL and AKG devices",
					"displayName": "Harman, JBL and AKG devices",
					"image": "harman-jbl-akg-v1.svg",
					"tpImage": "harman-jbl-akg-v1.png",
					"alt": "Harman, JBL and AKG icon",
					"isABTest": true,
					"isTSApiAvailable": false,
					"lucidTSUrl": "",
					"services": "",
					"availableServices": "",
					"isProductMappingNotAvailable": false
				}
			],
			"alttroubleshootertext": "",
			"tsTitle": "",
			"tsSubTitle": ""
		}
	],
	"itrepair": [
		{
			"name": "it-repair",
			"title": "Select your product",
			"subTitlex": "Select your product below and use our simple troubleshooting guide to diagnose the problem. If a repair is needed, we’ll take you through the steps to book online.<br /> If you have any problems during the troubleshooting or booking process, <a href='javascript:void(0);' class='get-in-touch link'>get in touch</a> and we can help.",
			"subTitle": "Select your product below and use our simple troubleshooting guide to diagnose the problem. If a repair is needed, we will take you through the steps to book online.",
			"categories": [
				{
					"name": "Monitor",
					"displayName": "Monitors",
					"image": "monitor.svg",
					"tpImage": "monitor.png",
					"alt": "Monitors icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/monitor.html",
					"services": [
						"Pickup service",
						"In Home Repair"
					],
					"availableServices": "PS|IH",
					"isProductMappingNotAvailable": true
				},
				{
					"name": "Galaxy Book",
					"displayName": "Galaxy Book",
					"image": "laptop.svg",
					"tpImage": "galaxy-book.png",
					"alt": "Galaxy Book icon",
					"isABTest": true,
					"isTSApiAvailable": true,
					"lucidTSUrl": "https://samcustdotcom.likewizesupport.com/sam/galaxybook.html",
					"services": [
						"Pickup service"
					],
					"availableServices": "PS",
					"isProductMappingNotAvailable": true
				},
				{
					"name": "Computing Accessories",
					"displayName": "Computing Accessories",
					"image": "computing-accesories.svg",
					"alt": "Computing Accessories icon",
					"isABTest": true,
					"isTSApiAvailable": false,
					"lucidTSUrl": "",
					"services": "",
					"availableServices": "",
					"isProductMappingNotAvailable": true
				}
			],
			"alttroubleshootertext": "If you have a Samsung memory card, storage media or other computing accessory, you can get support from the retailer you purchased from <a href='/uk/support/computing/how-do-i-book-my-pc-office-or-storage-product-for-repair/' class='link' target='_blank'>here</a>.",
			"tsTitle": "Troubleshooting guide",
			"tsSubTitle": ""
		}
	],
	"xxx": "copy end"
}
